module.exports = __webpack_public_path__ + "../resources/img/ic_sns_instagram_gray.92d695d2.svg";